export default __webpack_public_path__ + "static/media/tavi_medium@2x.0c478035.jpg";